module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-267.c99134df.svg";